import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IProgramRule } from '@ebb-v2/ebb-integration';

@Injectable({
  providedIn: 'root'
})
export abstract class ProgramRuleApiService {
  abstract getProgramRuleList(typeCodes: number[]): Observable<IProgramRule[]>;
}
